
import request from '@/utils/request'


export function exportData(data) {
  return request({
    url: 'CheckRunPosture/exportData',
    method: 'post',
    data
  })
}

export function getPageList(data) {
  return request({
    url: 'CheckRunPosture/getPageList',
    method: 'post',
    data
  })
}
